import { createFileRoute } from '@tanstack/react-router';

import { FeaturePlaceholderPage } from '../pages/FeaturePlaceholderPage';
import { ShigoFeature } from '../pages/shigo-feature';

export const Route = createFileRoute('/supply/')({
  component: SupplyIndexPage,
});

function SupplyIndexPage() {
  return <FeaturePlaceholderPage feature={ShigoFeature.Supply} />;
}
